<template>
  <pre class="overflow-auto">{{ parsedJson }}</pre>
</template>

<script>
import Field from "@skuhnow/vuetify-admin/src/mixins/field";

export default {
  mixins: [Field],
  computed: {
    parsedJson() {
      try {
        return JSON.parse(this.value);
      } catch (e) {
        return this.value;
      }
    }
  }
};
</script>
